import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MenuPositionX, MenuPositionY}                                                          from '@angular/material/menu';
import {PopoverDirective}                                                                      from '@src/app/shared/directives/popover.directive';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PopoverComponent implements OnInit
{
    @Input()
    public xPosition: MenuPositionX = 'after';

    @Input()
    public yPosition: MenuPositionY = 'below';

    @Input()
    public popoverContent!: TemplateRef<unknown>;

    @Input()
    public mode: 'toggle' | 'hover' = 'hover';

    @ViewChild(PopoverDirective, {static: false})
    private readonly popoverTrigger!: PopoverDirective;

    constructor(private readonly elementRef: ElementRef)
    {
    }

    public ngOnInit(): void
    {
        if (this.mode === 'toggle') {
            this.elementRef.nativeElement.addEventListener('click', () => this.popoverTrigger.toggleMenu());
        } else {
            this.elementRef.nativeElement.addEventListener('mouseenter', () => this.popoverTrigger.openMenu());
            this.elementRef.nativeElement.addEventListener('mouseleave', () => this.popoverTrigger.closeMenu());
        }
    }

    public open(): void
    {
        this.popoverTrigger.openMenu();
    }

    public close(): void
    {
        this.popoverTrigger.closeMenu();
    }
}